import { useEffect, useState } from 'react';

export const useWindowDimensions = (): { width: number; height: number } => {
  const [dimensions, setDimensions] = useState<{
    width: number;
    height: number;
  }>(() => {
    if (typeof window === 'undefined') {
      return { width: 375, height: 820 };
    }
    return {
      width: Math.min(window.innerWidth, 480),
      height: window.innerHeight,
    };
  });

  useEffect(() => {
    const handleResize = (): void => {
      setDimensions({
        width: Math.min(window.innerWidth, 480),
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return dimensions;
};
